import global from "../../../config/global";

const baseURL = global.apisUrl + "/companies";

export const companyURL = (id) => baseURL + `${id ? "/" + id : ""}`;

export const companyListURL = baseURL + "/list";

export const childCompaniesURL = baseURL + "/child-companies";

export const multiCompanyURL = baseURL + "/multi";

export const myCompanyURL = baseURL + "/my-company";

export const deleteCompanyById = (id) => baseURL + `/soft-delete/${id}`;

export const duplicateCompanyById = (id) => baseURL + `/${id}/duplicate`;

export const countryListURL = baseURL + "/country-list";
